import { buildTime, Config } from "../../Config";
import { PROVIDER_CONNECTION_TYPE } from "./constants";
import { SolrResponse, SolrWaterProvider, WaterProvider } from "./types";
export const get = <T>(url: string, options?: RequestInit): Promise<T> => {
    const hasQuestionMark = url.indexOf("?") > -1;
    // const refresh = Math.round(new Date().getTime() / (1000 * 60));
    const cacheTime = 1000 * 60 * 60 * 24 * 3;
    // const cacheTime = 1000 * 60;
    const refresh = Math.round(new Date().getTime() / cacheTime);

    return fetch(
        `${url ?? ""}${
            !hasQuestionMark
                ? `${options?.cache === "force-cache" ? `?refresh=${refresh}&buildTime=${buildTime}` : ""}`
                : `${options?.cache === "force-cache" ? `&refresh=${refresh}&buildTime=${buildTime}` : ""}`
        }`,
        options ?? {
            cache: "default"
        }
    )
        .then(response => {
            // response.headers.forEach(d => {
            //     console.log(d);
            //     // response.headers.get(d));
            // });
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            return response.json();
        })
        .then(body => {
            return body as T;
        })
        .catch(err => {
            console.log(err);
            return undefined;
        });
};

export const post = <T>(url: string, body: string): Promise<T> => {
    return fetch(url, {
        method: "POST",
        headers: {
            "Content-type": "application/json"
        },
        body
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            return response.json();
        })
        .then(body => {
            return body as T;
        })
        .catch(err => {
            console.log(err);
            return undefined;
        });
};

export const drupalApiGet = <T>(uri: string, options?: RequestInit): Promise<T> => {
    return get<T>(`${Config.drupalEndpoint}/${uri}?buildTime=${buildTime}`, options);
};

// export const solrApiGet = <T>(uri: string, options?: RequestInit): Promise<T> => {
//     return get<T>(
//         `${Config.solrEndpoint}/${uri}`,
//         options ?? {
//             cache: "force-cache"
//         }
//     );
// };

export const queryWaterProvider = (query: string, options?: RequestInit): Promise<SolrResponse<SolrWaterProvider>> => {
    return get<SolrResponse<SolrWaterProvider>>(
        `${Config.solrEndpoint}/select?${query ?? ""}`,
        Config.solrHasCredentials
            ? {
                  ...(options ?? {}),
                  cache: "force-cache",
                  headers: new Headers({
                      // "Content-type": "application/json",
                      Authorization: `Basic ${Buffer.from(`${Config.solrUsername}:${Config.solrPassword}`).toString(
                          "base64"
                      )}`
                  })
              }
            : {
                  ...(options ?? {}),
                  cache: "force-cache"
              }
    );
};

export const queryWaterProviderWithDocs = async (query: string, options?: RequestInit): Promise<WaterProvider[]> => {
    const solrProviders = await queryWaterProvider(query, options);
    return solrProviders?.response?.docs.map(
        ({
            its_tid,
            pure_strings_sname,
            pure_strings_stax_name,
            pure_strings_kapi_name,
            pure_strings_admin_id,
            pure_strings_type,
            pure_strings_connection_size_ct,
            pure_strings_residential_tariff_struct,
            fts_connection_size,
            fts_sewerage_connection_size,
            fts_population,
            fts_area,
            fts_dam_capacity,
            fts_dam_num,
            fts_employee_num,
            pure_strings_region,
            tm_X3b_en_description,
            geojsons_geometry,
            geojsons_scheme_geometry,
            bs_include_imported_water
        }) => {
            return {
                tid: its_tid,

                systemName: pure_strings_stax_name,

                kapiName: pure_strings_kapi_name,

                // display name
                name: pure_strings_sname,

                // admin id
                adminId: pure_strings_admin_id,

                // type
                type: pure_strings_type,

                // connection size category
                connectionSizeCategory: pure_strings_connection_size_ct,

                // residential tariff structure
                residentialTariffStruct: pure_strings_residential_tariff_struct,

                // connection size amount
                connectionSize:
                    pure_strings_connection_size_ct === PROVIDER_CONNECTION_TYPE.bulk ? null : fts_connection_size,

                // sewerage connection size
                sewerageConnectionSize:
                    pure_strings_connection_size_ct === PROVIDER_CONNECTION_TYPE.bulk
                        ? null
                        : fts_sewerage_connection_size,
                // fts_sewerage_connection_size,

                // region
                region: pure_strings_region,

                // population
                population: fts_population,

                // area
                area: fts_area,

                // dam capacity
                damCapacity: fts_dam_capacity,

                // dam num
                damNum: fts_dam_num,

                // employee num
                employeeNum: fts_employee_num,

                // description
                description: tm_X3b_en_description?.[0],

                includeImportedWater: bs_include_imported_water,

                geometry:
                    geojsons_geometry == null || geojsons_geometry?.trim() === ""
                        ? null
                        : JSON.parse(geojsons_geometry),

                schemeGeometry:
                    geojsons_scheme_geometry == null || geojsons_scheme_geometry?.trim() === ""
                        ? null
                        : JSON.parse(geojsons_scheme_geometry)
            };
        }
    );
};
